import { Box, Card, CardProps } from '@chakra-ui/react'

type Props = {
  minH?: CardProps['minH']
  maxH?: CardProps['maxH']
  children: React.ReactNode
}

export const WIDGET_MIN_HEIGHT = '360px'

export const DashboardWidget: React.FC<Props> = ({ minH, maxH, children }) => {
  return (
    <Card
      variant="outline"
      borderRadius="base"
      boxShadow="none"
      w="full"
      padding={6}
      minH={minH ?? WIDGET_MIN_HEIGHT}
      maxH={maxH}
      display="grid"
      gridTemplateColumns="1fr"
      gridTemplateRows="minmax(0, 1fr)"
    >
      <Box>{children}</Box>
    </Card>
  )
}
